var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 370,
    viewBox: "0 0 344 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V370C102.424 370 185.449 287.176 185.449 185C185.449 82.8236 102.424 0 0 0Z",
    fill: "#F7B24F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.449 17.9048V352.095C247.993 322.367 291.227 258.716 291.227 185C291.227 111.284 247.993 47.633 185.449 17.9048Z",
    fill: "#F7B24F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.965 54.4834V315.507C323.359 282.054 344 235.928 344 184.99C344 134.052 323.359 87.9364 289.965 54.4834Z",
    fill: "#F7B24F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow);
export default __webpack_public_path__ + "static/media/yellow.c6f92c9bd0497b1d18bc5d196ed83d80.svg";
export { ForwardRef as ReactComponent };